import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Navegação */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-primary-600 hover:text-primary-500 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao início
          </Link>
        </div>

        {/* Cabeçalho */}
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-secondary-900 mb-4 font-display">
            Política de Privacidade
          </h1>
          <p className="text-lg text-secondary-600">
            Última atualização: 16 de setembro de 2024
          </p>
        </div>

        {/* Conteúdo */}
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">1. Introdução</h2>
            <p className="text-secondary-700 mb-4">
              A M42Orion Tecnologia Ltda., operadora da plataforma BIZREP, está comprometida em proteger 
              sua privacidade e dados pessoais. Esta Política de Privacidade explica como coletamos, 
              usamos, divulgamos e protegemos suas informações quando você usa nossos serviços.
            </p>
            <p className="text-secondary-700">
              Ao usar o BIZREP, você concorda com a coleta e uso de informações de acordo com esta política.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">2. Informações que Coletamos</h2>
            
            <h3 className="text-xl font-semibold text-secondary-900 mb-3">2.1 Informações Fornecidas por Você</h3>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Dados de cadastro (nome, e-mail, telefone, informações da empresa)</li>
              <li>Informações de pagamento (processadas por terceiros seguros)</li>
              <li>Conteúdo que você cria ou compartilha na plataforma</li>
              <li>Comunicações conosco (suporte, feedback)</li>
            </ul>

            <h3 className="text-xl font-semibold text-secondary-900 mb-3">2.2 Informações Coletadas Automaticamente</h3>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Dados de uso da plataforma (páginas visitadas, tempo de uso)</li>
              <li>Informações do dispositivo (tipo, sistema operacional, navegador)</li>
              <li>Endereço IP e dados de localização aproximada</li>
              <li>Cookies e tecnologias similares</li>
            </ul>

            <h3 className="text-xl font-semibold text-secondary-900 mb-3">2.3 Informações de Terceiros</h3>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Dados de redes sociais conectadas (com sua autorização)</li>
              <li>Informações de integrações autorizadas (WhatsApp, Google, Meta)</li>
              <li>Dados de análise de campanhas publicitárias</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">3. Como Usamos suas Informações</h2>
            <p className="text-secondary-700 mb-4">
              Utilizamos suas informações para:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Fornecer, operar e manter nossos serviços</li>
              <li>Processar transações e gerenciar sua conta</li>
              <li>Personalizar sua experiência na plataforma</li>
              <li>Treinar e melhorar nossos assistentes de IA</li>
              <li>Enviar comunicações importantes sobre o serviço</li>
              <li>Fornecer suporte ao cliente</li>
              <li>Detectar, prevenir e resolver problemas técnicos</li>
              <li>Cumprir obrigações legais e regulamentares</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">4. Compartilhamento de Informações</h2>
            <p className="text-secondary-700 mb-4">
              Não vendemos suas informações pessoais. Podemos compartilhar suas informações nas seguintes situações:
            </p>
            
            <h3 className="text-xl font-semibold text-secondary-900 mb-3">4.1 Provedores de Serviços</h3>
            <p className="text-secondary-700 mb-4">
              Compartilhamos informações com terceiros que prestam serviços em nosso nome, incluindo:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Processadores de pagamento</li>
              <li>Provedores de hospedagem e infraestrutura</li>
              <li>Serviços de análise e monitoramento</li>
              <li>Provedores de suporte ao cliente</li>
            </ul>

            <h3 className="text-xl font-semibold text-secondary-900 mb-3">4.2 Integrações Autorizadas</h3>
            <p className="text-secondary-700 mb-4">
              Com sua autorização expressa, integramos com:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>WhatsApp Business API</li>
              <li>Meta (Facebook/Instagram) APIs</li>
              <li>Google Ads e Analytics</li>
              <li>Outras plataformas que você escolher conectar</li>
            </ul>

            <h3 className="text-xl font-semibold text-secondary-900 mb-3">4.3 Requisitos Legais</h3>
            <p className="text-secondary-700 mb-4">
              Podemos divulgar suas informações se exigido por lei ou em resposta a solicitações válidas 
              de autoridades públicas.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">5. Segurança dos Dados</h2>
            <p className="text-secondary-700 mb-4">
              Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Criptografia de dados em trânsito e em repouso</li>
              <li>Controles de acesso rigorosos</li>
              <li>Monitoramento contínuo de segurança</li>
              <li>Auditorias regulares de segurança</li>
              <li>Treinamento de funcionários em proteção de dados</li>
            </ul>
            <p className="text-secondary-700">
              Embora nos esforcemos para proteger suas informações, nenhum método de transmissão 
              pela internet é 100% seguro.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">6. Seus Direitos</h2>
            <p className="text-secondary-700 mb-4">
              De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem os seguintes direitos:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Confirmação da existência de tratamento de dados</li>
              <li>Acesso aos seus dados pessoais</li>
              <li>Correção de dados incompletos, inexatos ou desatualizados</li>
              <li>Anonimização, bloqueio ou eliminação de dados desnecessários</li>
              <li>Portabilidade dos dados</li>
              <li>Eliminação dos dados tratados com consentimento</li>
              <li>Revogação do consentimento</li>
            </ul>
            <p className="text-secondary-700">
              Para exercer esses direitos, entre em contato conosco através dos canais indicados no final desta política.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">7. Retenção de Dados</h2>
            <p className="text-secondary-700 mb-4">
              Mantemos suas informações pessoais apenas pelo tempo necessário para:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Fornecer nossos serviços</li>
              <li>Cumprir obrigações legais</li>
              <li>Resolver disputas</li>
              <li>Fazer cumprir nossos acordos</li>
            </ul>
            <p className="text-secondary-700">
              Quando não precisarmos mais de suas informações, as excluiremos ou anonimizaremos de forma segura.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">8. Cookies e Tecnologias Similares</h2>
            <p className="text-secondary-700 mb-4">
              Usamos cookies e tecnologias similares para:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Manter você logado na plataforma</li>
              <li>Lembrar suas preferências</li>
              <li>Analisar o uso da plataforma</li>
              <li>Personalizar conteúdo e anúncios</li>
            </ul>
            <p className="text-secondary-700">
              Você pode controlar o uso de cookies através das configurações do seu navegador.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">9. Transferências Internacionais</h2>
            <p className="text-secondary-700 mb-4">
              Alguns de nossos provedores de serviços podem estar localizados fora do Brasil. 
              Quando transferimos dados internacionalmente, garantimos que:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>O país de destino oferece nível adequado de proteção</li>
              <li>Implementamos salvaguardas contratuais apropriadas</li>
              <li>Obtemos seu consentimento quando necessário</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">10. Menores de Idade</h2>
            <p className="text-secondary-700 mb-4">
              Nossos serviços não são direcionados a menores de 18 anos. Não coletamos intencionalmente 
              informações pessoais de menores de idade.
            </p>
            <p className="text-secondary-700">
              Se tomarmos conhecimento de que coletamos dados de um menor sem consentimento parental, 
              tomaremos medidas para remover essas informações.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">11. Alterações nesta Política</h2>
            <p className="text-secondary-700 mb-4">
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre 
              mudanças significativas através de:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>E-mail para o endereço registrado em sua conta</li>
              <li>Aviso na plataforma</li>
              <li>Atualização da data no topo desta política</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">12. Contato</h2>
            <p className="text-secondary-700 mb-4">
              Para questões sobre esta Política de Privacidade ou para exercer seus direitos, 
              entre em contato conosco:
            </p>
            <div className="bg-secondary-50 p-4 rounded-lg">
              <p className="text-secondary-700 mb-2">
                <strong>Encarregado de Proteção de Dados (DPO)</strong>
              </p>
              <p className="text-secondary-700 mb-2">
                M42Orion Tecnologia Ltda.
              </p>
              <p className="text-secondary-700 mb-2">
                E-mail: dpo@m42orion.com
              </p>
              <p className="text-secondary-700 mb-2">
                E-mail geral: contato@m42orion.com
              </p>
              <p className="text-secondary-700 mb-2">
                Telefone: (11) 9999-9999
              </p>
              <p className="text-secondary-700">
                Endereço: Rua das Tecnologias, 123 - São Paulo, SP, CEP 01234-567
              </p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;

